// Generated file : do not modify

import * as signalR from '@microsoft/signalr';
import { storeSession } from '@/generated/stores';
import { ListItem } from '@/extend/classes/ListData';
import Etablissement from '@/extend/classes/Etablissement';
import Synchro98 from '@/extend/classes/Synchro98';
import Route from '@/extend/classes/Route';
import ChatItem from '@/extend/classes/ChatItem';
import Dialog from '@/extend/classes/Dialog';
import { DialogActionData } from '@/generated/classes/Dialog';
import Cart from '@/extend/classes/Cart';
import { PayboxData } from '@/generated/classes/Carte';
import GraphData from '@/extend/classes/GraphData';
import MetaAttrib from '@/extend/classes/MetaAttrib';
import { WidgetData } from '@/generated/classes/DashboardWidget';

export interface ContratSignContrat {
  (value: string): void;
}

export interface EtablissementFractionUpdated {
  (value: Etablissement): void;
}

export interface Synchro98Progress {
  (value: Synchro98): void;
}

export interface RouteShowRoute {
  (value: Route): void;
}

export interface FilesProgress {
  (value: string): void;
}

export interface ChatItemCreated {
  (value: ChatItem): void;
}

export interface DialogQuestion {
  (value: Dialog): void;
}

export interface DialogAction {
  (value: DialogActionData): void;
}

export interface DialogRefresh {
  (value: Dialog): void;
}

export interface CartUpdated {
  (value: Cart): void;
}

export interface CartTagUpdated {
  (value: Cart): void;
}

export interface TransactionRapproched {
  (value: boolean): void;
}

export interface CarteLoadPaybox {
  (value: PayboxData): void;
}

export interface GraphDataAdditional {
  (value: GraphData): void;
}

export interface MetaAttribDefine {
  (value: MetaAttrib): void;
}

export interface DashboardWidgetUpdated {
  (value: WidgetData): void;
}

export interface AccidentTravailCreated {
  (value: ListItem): void;
}

export interface AccidentTravailUpdated {
  (value: ListItem): void;
}

export interface AccidentTravailDeleted {
  (value: ListItem): void;
}

export interface AccountEntryCreated {
  (value: ListItem): void;
}

export interface AccountEntryUpdated {
  (value: ListItem): void;
}

export interface AccountEntryDeleted {
  (value: ListItem): void;
}

export interface ActiviteCreated {
  (value: ListItem): void;
}

export interface ActiviteUpdated {
  (value: ListItem): void;
}

export interface ActiviteDeleted {
  (value: ListItem): void;
}

export interface ActualiteCreated {
  (value: ListItem): void;
}

export interface ActualiteUpdated {
  (value: ListItem): void;
}

export interface ActualiteDeleted {
  (value: ListItem): void;
}

export interface AdresseCreated {
  (value: ListItem): void;
}

export interface AdresseUpdated {
  (value: ListItem): void;
}

export interface AdresseDeleted {
  (value: ListItem): void;
}

export interface ApprentiCreated {
  (value: ListItem): void;
}

export interface ApprentiUpdated {
  (value: ListItem): void;
}

export interface ApprentiDeleted {
  (value: ListItem): void;
}

export interface AttestationCreated {
  (value: ListItem): void;
}

export interface AttestationUpdated {
  (value: ListItem): void;
}

export interface AttestationDeleted {
  (value: ListItem): void;
}

export interface AttestationDefCreated {
  (value: ListItem): void;
}

export interface AttestationDefUpdated {
  (value: ListItem): void;
}

export interface AttestationDefDeleted {
  (value: ListItem): void;
}

export interface AuthorizedCreditCreated {
  (value: ListItem): void;
}

export interface AuthorizedCreditUpdated {
  (value: ListItem): void;
}

export interface AuthorizedCreditDeleted {
  (value: ListItem): void;
}

export interface BankCreated {
  (value: ListItem): void;
}

export interface BankUpdated {
  (value: ListItem): void;
}

export interface BankDeleted {
  (value: ListItem): void;
}

export interface BillCreated {
  (value: ListItem): void;
}

export interface BillUpdated {
  (value: ListItem): void;
}

export interface BillDeleted {
  (value: ListItem): void;
}

export interface ChatCreated {
  (value: ListItem): void;
}

export interface ChatUpdated {
  (value: ListItem): void;
}

export interface ChatDeleted {
  (value: ListItem): void;
}

export interface CiviliteCreated {
  (value: ListItem): void;
}

export interface CiviliteUpdated {
  (value: ListItem): void;
}

export interface CiviliteDeleted {
  (value: ListItem): void;
}

export interface ClientCreated {
  (value: ListItem): void;
}

export interface ClientUpdated {
  (value: ListItem): void;
}

export interface ClientDeleted {
  (value: ListItem): void;
}

export interface ContactCreated {
  (value: ListItem): void;
}

export interface ContactUpdated {
  (value: ListItem): void;
}

export interface ContactDeleted {
  (value: ListItem): void;
}

export interface ContratCreated {
  (value: ListItem): void;
}

export interface ContratUpdated {
  (value: ListItem): void;
}

export interface ContratDeleted {
  (value: ListItem): void;
}

export interface ContratTemplateCreated {
  (value: ListItem): void;
}

export interface ContratTemplateUpdated {
  (value: ListItem): void;
}

export interface ContratTemplateDeleted {
  (value: ListItem): void;
}

export interface CreneauCreated {
  (value: ListItem): void;
}

export interface CreneauUpdated {
  (value: ListItem): void;
}

export interface CreneauDeleted {
  (value: ListItem): void;
}

export interface DeliveryCreated {
  (value: ListItem): void;
}

export interface DeliveryUpdated {
  (value: ListItem): void;
}

export interface DeliveryDeleted {
  (value: ListItem): void;
}

export interface DocumentCreated {
  (value: ListItem): void;
}

export interface DocumentUpdated {
  (value: ListItem): void;
}

export interface DocumentDeleted {
  (value: ListItem): void;
}

export interface DocumentTypeCreated {
  (value: ListItem): void;
}

export interface DocumentTypeUpdated {
  (value: ListItem): void;
}

export interface DocumentTypeDeleted {
  (value: ListItem): void;
}

export interface EtablissementCreated {
  (value: ListItem): void;
}

export interface EtablissementUpdated {
  (value: ListItem): void;
}

export interface EtablissementDeleted {
  (value: ListItem): void;
}

export interface FractionDsnCreated {
  (value: ListItem): void;
}

export interface FractionDsnUpdated {
  (value: ListItem): void;
}

export interface FractionDsnDeleted {
  (value: ListItem): void;
}

export interface LieuCreated {
  (value: ListItem): void;
}

export interface LieuUpdated {
  (value: ListItem): void;
}

export interface LieuDeleted {
  (value: ListItem): void;
}

export interface MailCreated {
  (value: ListItem): void;
}

export interface MailUpdated {
  (value: ListItem): void;
}

export interface MailDeleted {
  (value: ListItem): void;
}

export interface ManualBillingDocumentCreated {
  (value: ListItem): void;
}

export interface ManualBillingDocumentUpdated {
  (value: ListItem): void;
}

export interface ManualBillingDocumentDeleted {
  (value: ListItem): void;
}

export interface MetaAttribCreated {
  (value: ListItem): void;
}

export interface MetaAttribUpdated {
  (value: ListItem): void;
}

export interface MetaAttribDeleted {
  (value: ListItem): void;
}

export interface NotifCreated {
  (value: ListItem): void;
}

export interface NotifUpdated {
  (value: ListItem): void;
}

export interface NotifDeleted {
  (value: ListItem): void;
}

export interface NumeroCreated {
  (value: ListItem): void;
}

export interface NumeroUpdated {
  (value: ListItem): void;
}

export interface NumeroDeleted {
  (value: ListItem): void;
}

export interface NumeroObjetCreated {
  (value: ListItem): void;
}

export interface NumeroObjetUpdated {
  (value: ListItem): void;
}

export interface NumeroObjetDeleted {
  (value: ListItem): void;
}

export interface ObjetMetierCreated {
  (value: ListItem): void;
}

export interface ObjetMetierUpdated {
  (value: ListItem): void;
}

export interface ObjetMetierDeleted {
  (value: ListItem): void;
}

export interface PaieCreated {
  (value: ListItem): void;
}

export interface PaieUpdated {
  (value: ListItem): void;
}

export interface PaieDeleted {
  (value: ListItem): void;
}

export interface PaymentMeansCreated {
  (value: ListItem): void;
}

export interface PaymentMeansUpdated {
  (value: ListItem): void;
}

export interface PaymentMeansDeleted {
  (value: ListItem): void;
}

export interface PlageCreneauCreated {
  (value: ListItem): void;
}

export interface PlageCreneauUpdated {
  (value: ListItem): void;
}

export interface PlageCreneauDeleted {
  (value: ListItem): void;
}

export interface ProjetCreated {
  (value: ListItem): void;
}

export interface ProjetUpdated {
  (value: ListItem): void;
}

export interface ProjetDeleted {
  (value: ListItem): void;
}

export interface QualiteCreated {
  (value: ListItem): void;
}

export interface QualiteUpdated {
  (value: ListItem): void;
}

export interface QualiteDeleted {
  (value: ListItem): void;
}

export interface RibCreated {
  (value: ListItem): void;
}

export interface RibUpdated {
  (value: ListItem): void;
}

export interface RibDeleted {
  (value: ListItem): void;
}

export interface RubriqueCreated {
  (value: ListItem): void;
}

export interface RubriqueUpdated {
  (value: ListItem): void;
}

export interface RubriqueDeleted {
  (value: ListItem): void;
}

export interface SalarieCreated {
  (value: ListItem): void;
}

export interface SalarieUpdated {
  (value: ListItem): void;
}

export interface SalarieDeleted {
  (value: ListItem): void;
}

export interface SubscriptionCreated {
  (value: ListItem): void;
}

export interface SubscriptionUpdated {
  (value: ListItem): void;
}

export interface SubscriptionDeleted {
  (value: ListItem): void;
}

export interface SubscriptionTypeCreated {
  (value: ListItem): void;
}

export interface SubscriptionTypeUpdated {
  (value: ListItem): void;
}

export interface SubscriptionTypeDeleted {
  (value: ListItem): void;
}

export interface SupportCreated {
  (value: ListItem): void;
}

export interface SupportUpdated {
  (value: ListItem): void;
}

export interface SupportDeleted {
  (value: ListItem): void;
}

export interface TransactionCreated {
  (value: ListItem): void;
}

export interface TransactionUpdated {
  (value: ListItem): void;
}

export interface TransactionDeleted {
  (value: ListItem): void;
}

export interface UserCreated {
  (value: ListItem): void;
}

export interface UserUpdated {
  (value: ListItem): void;
}

export interface UserDeleted {
  (value: ListItem): void;
}

export interface WizardItemCreated {
  (value: ListItem): void;
}

export interface WizardItemUpdated {
  (value: ListItem): void;
}

export interface WizardItemDeleted {
  (value: ListItem): void;
}

export default class HubServices {
  public static connection: signalR.HubConnection;
  private static ready = false;
  private static dialogRegistered = false;
  private static dialogRegistration: Promise<void> | null = null;

  public static hubReady (): boolean {
    return HubServices.ready;
  }

  public static setConnection (connection: signalR.HubConnection, ready: boolean) {
    HubServices.connection = connection;
    HubServices.ready = ready;
    if (!ready) {
      HubServices.dialogRegistered = false;
      HubServices.dialogRegistration = null;
    }
    if (ready) {
      if (HubServices.contratSignContrat != null) {
        HubServices.onContratSignContrat(HubServices.contratSignContrat);
      }
      if (HubServices.etablissementFractionUpdated != null) {
        HubServices.onEtablissementFractionUpdated(HubServices.etablissementFractionUpdated);
      }
      if (HubServices.synchro98Progress != null) {
        HubServices.onSynchro98Progress(HubServices.synchro98Progress);
      }
      if (HubServices.routeShowRoute != null) {
        HubServices.onRouteShowRoute(HubServices.routeShowRoute);
      }
      if (HubServices.filesProgress != null) {
        HubServices.onFilesProgress(HubServices.filesProgress);
      }
      if (HubServices.chatItemCreated != null) {
        HubServices.onChatItemCreated(HubServices.chatItemCreated);
      }
      if (HubServices.dialogQuestion != null) {
        HubServices.onDialogQuestion(HubServices.dialogQuestion);
      }
      if (HubServices.dialogAction != null) {
        HubServices.onDialogAction(HubServices.dialogAction);
      }
      if (HubServices.dialogRefresh != null) {
        HubServices.onDialogRefresh(HubServices.dialogRefresh);
      }
      if (HubServices.cartUpdated != null) {
        HubServices.onCartUpdated(HubServices.cartUpdated);
      }
      if (HubServices.cartTagUpdated != null) {
        HubServices.onCartTagUpdated(HubServices.cartTagUpdated);
      }
      if (HubServices.transactionRapproched != null) {
        HubServices.onTransactionRapproched(HubServices.transactionRapproched);
      }
      if (HubServices.carteLoadPaybox != null) {
        HubServices.onCarteLoadPaybox(HubServices.carteLoadPaybox);
      }
      if (HubServices.graphDataAdditional != null) {
        HubServices.onGraphDataAdditional(HubServices.graphDataAdditional);
      }
      if (HubServices.metaAttribDefine != null) {
        HubServices.onMetaAttribDefine(HubServices.metaAttribDefine);
      }
      if (HubServices.dashboardWidgetUpdated != null) {
        HubServices.onDashboardWidgetUpdated(HubServices.dashboardWidgetUpdated);
      }
      if (HubServices.accidentTravailCreated != null) {
        HubServices.registerAccidentTravail(HubServices.accidentTravailCreated, HubServices.accidentTravailUpdated, HubServices.accidentTravailDeleted);
      }
      if (HubServices.accountEntryCreated != null) {
        HubServices.registerAccountEntry(HubServices.accountEntryCreated, HubServices.accountEntryUpdated, HubServices.accountEntryDeleted);
      }
      if (HubServices.activiteCreated != null) {
        HubServices.registerActivite(HubServices.activiteCreated, HubServices.activiteUpdated, HubServices.activiteDeleted);
      }
      if (HubServices.actualiteCreated != null) {
        HubServices.registerActualite(HubServices.actualiteCreated, HubServices.actualiteUpdated, HubServices.actualiteDeleted);
      }
      if (HubServices.adresseCreated != null) {
        HubServices.registerAdresse(HubServices.adresseCreated, HubServices.adresseUpdated, HubServices.adresseDeleted);
      }
      if (HubServices.apprentiCreated != null) {
        HubServices.registerApprenti(HubServices.apprentiCreated, HubServices.apprentiUpdated, HubServices.apprentiDeleted);
      }
      if (HubServices.attestationCreated != null) {
        HubServices.registerAttestation(HubServices.attestationCreated, HubServices.attestationUpdated, HubServices.attestationDeleted);
      }
      if (HubServices.attestationDefCreated != null) {
        HubServices.registerAttestationDef(HubServices.attestationDefCreated, HubServices.attestationDefUpdated, HubServices.attestationDefDeleted);
      }
      if (HubServices.authorizedCreditCreated != null) {
        HubServices.registerAuthorizedCredit(HubServices.authorizedCreditCreated, HubServices.authorizedCreditUpdated, HubServices.authorizedCreditDeleted);
      }
      if (HubServices.bankCreated != null) {
        HubServices.registerBank(HubServices.bankCreated, HubServices.bankUpdated, HubServices.bankDeleted);
      }
      if (HubServices.billCreated != null) {
        HubServices.registerBill(HubServices.billCreated, HubServices.billUpdated, HubServices.billDeleted);
      }
      if (HubServices.chatCreated != null) {
        HubServices.registerChat(HubServices.chatCreated, HubServices.chatUpdated, HubServices.chatDeleted);
      }
      if (HubServices.civiliteCreated != null) {
        HubServices.registerCivilite(HubServices.civiliteCreated, HubServices.civiliteUpdated, HubServices.civiliteDeleted);
      }
      if (HubServices.clientCreated != null) {
        HubServices.registerClient(HubServices.clientCreated, HubServices.clientUpdated, HubServices.clientDeleted);
      }
      if (HubServices.contactCreated != null) {
        HubServices.registerContact(HubServices.contactCreated, HubServices.contactUpdated, HubServices.contactDeleted);
      }
      if (HubServices.contratCreated != null) {
        HubServices.registerContrat(HubServices.contratCreated, HubServices.contratUpdated, HubServices.contratDeleted);
      }
      if (HubServices.contratTemplateCreated != null) {
        HubServices.registerContratTemplate(HubServices.contratTemplateCreated, HubServices.contratTemplateUpdated, HubServices.contratTemplateDeleted);
      }
      if (HubServices.creneauCreated != null) {
        HubServices.registerCreneau(HubServices.creneauCreated, HubServices.creneauUpdated, HubServices.creneauDeleted);
      }
      if (HubServices.deliveryCreated != null) {
        HubServices.registerDelivery(HubServices.deliveryCreated, HubServices.deliveryUpdated, HubServices.deliveryDeleted);
      }
      if (HubServices.documentCreated != null) {
        HubServices.registerDocument(HubServices.documentCreated, HubServices.documentUpdated, HubServices.documentDeleted);
      }
      if (HubServices.documentTypeCreated != null) {
        HubServices.registerDocumentType(HubServices.documentTypeCreated, HubServices.documentTypeUpdated, HubServices.documentTypeDeleted);
      }
      if (HubServices.etablissementCreated != null) {
        HubServices.registerEtablissement(HubServices.etablissementCreated, HubServices.etablissementUpdated, HubServices.etablissementDeleted);
      }
      if (HubServices.fractionDsnCreated != null) {
        HubServices.registerFractionDsn(HubServices.fractionDsnCreated, HubServices.fractionDsnUpdated, HubServices.fractionDsnDeleted);
      }
      if (HubServices.lieuCreated != null) {
        HubServices.registerLieu(HubServices.lieuCreated, HubServices.lieuUpdated, HubServices.lieuDeleted);
      }
      if (HubServices.mailCreated != null) {
        HubServices.registerMail(HubServices.mailCreated, HubServices.mailUpdated, HubServices.mailDeleted);
      }
      if (HubServices.manualBillingDocumentCreated != null) {
        HubServices.registerManualBillingDocument(HubServices.manualBillingDocumentCreated, HubServices.manualBillingDocumentUpdated, HubServices.manualBillingDocumentDeleted);
      }
      if (HubServices.metaAttribCreated != null) {
        HubServices.registerMetaAttrib(HubServices.metaAttribCreated, HubServices.metaAttribUpdated, HubServices.metaAttribDeleted);
      }
      if (HubServices.notifCreated != null) {
        HubServices.registerNotif(HubServices.notifCreated, HubServices.notifUpdated, HubServices.notifDeleted);
      }
      if (HubServices.numeroCreated != null) {
        HubServices.registerNumero(HubServices.numeroCreated, HubServices.numeroUpdated, HubServices.numeroDeleted);
      }
      if (HubServices.numeroObjetCreated != null) {
        HubServices.registerNumeroObjet(HubServices.numeroObjetCreated, HubServices.numeroObjetUpdated, HubServices.numeroObjetDeleted);
      }
      if (HubServices.objetMetierCreated != null) {
        HubServices.registerObjetMetier(HubServices.objetMetierCreated, HubServices.objetMetierUpdated, HubServices.objetMetierDeleted);
      }
      if (HubServices.paieCreated != null) {
        HubServices.registerPaie(HubServices.paieCreated, HubServices.paieUpdated, HubServices.paieDeleted);
      }
      if (HubServices.paymentMeansCreated != null) {
        HubServices.registerPaymentMeans(HubServices.paymentMeansCreated, HubServices.paymentMeansUpdated, HubServices.paymentMeansDeleted);
      }
      if (HubServices.plageCreneauCreated != null) {
        HubServices.registerPlageCreneau(HubServices.plageCreneauCreated, HubServices.plageCreneauUpdated, HubServices.plageCreneauDeleted);
      }
      if (HubServices.projetCreated != null) {
        HubServices.registerProjet(HubServices.projetCreated, HubServices.projetUpdated, HubServices.projetDeleted);
      }
      if (HubServices.qualiteCreated != null) {
        HubServices.registerQualite(HubServices.qualiteCreated, HubServices.qualiteUpdated, HubServices.qualiteDeleted);
      }
      if (HubServices.ribCreated != null) {
        HubServices.registerRib(HubServices.ribCreated, HubServices.ribUpdated, HubServices.ribDeleted);
      }
      if (HubServices.rubriqueCreated != null) {
        HubServices.registerRubrique(HubServices.rubriqueCreated, HubServices.rubriqueUpdated, HubServices.rubriqueDeleted);
      }
      if (HubServices.salarieCreated != null) {
        HubServices.registerSalarie(HubServices.salarieCreated, HubServices.salarieUpdated, HubServices.salarieDeleted);
      }
      if (HubServices.subscriptionCreated != null) {
        HubServices.registerSubscription(HubServices.subscriptionCreated, HubServices.subscriptionUpdated, HubServices.subscriptionDeleted);
      }
      if (HubServices.subscriptionTypeCreated != null) {
        HubServices.registerSubscriptionType(HubServices.subscriptionTypeCreated, HubServices.subscriptionTypeUpdated, HubServices.subscriptionTypeDeleted);
      }
      if (HubServices.supportCreated != null) {
        HubServices.registerSupport(HubServices.supportCreated, HubServices.supportUpdated, HubServices.supportDeleted);
      }
      if (HubServices.transactionCreated != null) {
        HubServices.registerTransaction(HubServices.transactionCreated, HubServices.transactionUpdated, HubServices.transactionDeleted);
      }
      if (HubServices.userCreated != null) {
        HubServices.registerUser(HubServices.userCreated, HubServices.userUpdated, HubServices.userDeleted);
      }
      if (HubServices.wizardItemCreated != null) {
        HubServices.registerWizardItem(HubServices.wizardItemCreated, HubServices.wizardItemUpdated, HubServices.wizardItemDeleted);
      }
    }
  }

  private static contratSignContrat: ContratSignContrat;
  public static onContratSignContrat (contratSignContrat: ContratSignContrat) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterContrat', storeSession.httpToken);
      HubServices.connection.on('ContratSignContrat', (value: string) => {
        HubServices.contratSignContrat(value);
      });
    }
    HubServices.contratSignContrat = contratSignContrat;
  }

  private static etablissementFractionUpdated: EtablissementFractionUpdated;
  public static onEtablissementFractionUpdated (etablissementFractionUpdated: EtablissementFractionUpdated) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterEtablissement', storeSession.httpToken);
      HubServices.connection.on('EtablissementFractionUpdated', (value: Etablissement) => {
        HubServices.etablissementFractionUpdated(value);
      });
    }
    HubServices.etablissementFractionUpdated = etablissementFractionUpdated;
  }

  private static synchro98Progress: Synchro98Progress;
  public static onSynchro98Progress (synchro98Progress: Synchro98Progress) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSynchro98', storeSession.httpToken);
      HubServices.connection.on('Synchro98Progress', (value: Synchro98) => {
        HubServices.synchro98Progress(value);
      });
    }
    HubServices.synchro98Progress = synchro98Progress;
  }

  private static routeShowRoute: RouteShowRoute;
  public static onRouteShowRoute (routeShowRoute: RouteShowRoute) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterRoute', storeSession.httpToken);
      HubServices.connection.on('RouteShowRoute', (value: Route) => {
        HubServices.routeShowRoute(value);
      });
    }
    HubServices.routeShowRoute = routeShowRoute;
  }

  private static filesProgress: FilesProgress;
  public static onFilesProgress (filesProgress: FilesProgress) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterFiles', storeSession.httpToken);
      HubServices.connection.on('FilesProgress', (value: string) => {
        HubServices.filesProgress(value);
      });
    }
    HubServices.filesProgress = filesProgress;
  }

  private static chatItemCreated: ChatItemCreated;
  public static onChatItemCreated (chatItemCreated: ChatItemCreated) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterChat', storeSession.httpToken);
      HubServices.connection.on('ChatItemCreated', (value: ChatItem) => {
        HubServices.chatItemCreated(value);
      });
    }
    HubServices.chatItemCreated = chatItemCreated;
  }

  private static dialogQuestion: DialogQuestion;
  public static onDialogQuestion (dialogQuestion: DialogQuestion) {
    HubServices.dialogQuestion = dialogQuestion;
    HubServices.registerDialog();
  }

  private static dialogAction: DialogAction;
  public static onDialogAction (dialogAction: DialogAction) {
    HubServices.dialogAction = dialogAction;
    HubServices.registerDialog();
  }

  private static dialogRefresh: DialogRefresh;
  public static onDialogRefresh (dialogRefresh: DialogRefresh) {
    HubServices.dialogRefresh = dialogRefresh;
    HubServices.registerDialog();
  }

  private static cartUpdated: CartUpdated;
  public static onCartUpdated (cartUpdated: CartUpdated) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCart', storeSession.httpToken);
      HubServices.connection.on('CartUpdated', (value: Cart) => {
        HubServices.cartUpdated(value);
      });
    }
    HubServices.cartUpdated = cartUpdated;
  }

  private static cartTagUpdated: CartTagUpdated;
  public static onCartTagUpdated (cartTagUpdated: CartTagUpdated) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCart', storeSession.httpToken);
      HubServices.connection.on('CartTagUpdated', (value: Cart) => {
        HubServices.cartTagUpdated(value);
      });
    }
    HubServices.cartTagUpdated = cartTagUpdated;
  }

  private static transactionRapproched: TransactionRapproched;
  public static onTransactionRapproched (transactionRapproched: TransactionRapproched) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterTransaction', storeSession.httpToken);
      HubServices.connection.on('TransactionRapproched', (value: boolean) => {
        HubServices.transactionRapproched(value);
      });
    }
    HubServices.transactionRapproched = transactionRapproched;
  }

  private static carteLoadPaybox: CarteLoadPaybox;
  public static onCarteLoadPaybox (carteLoadPaybox: CarteLoadPaybox) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCarte', storeSession.httpToken);
      HubServices.connection.on('CarteLoadPaybox', (value: PayboxData) => {
        HubServices.carteLoadPaybox(value);
      });
    }
    HubServices.carteLoadPaybox = carteLoadPaybox;
  }

  private static graphDataAdditional: GraphDataAdditional;
  public static onGraphDataAdditional (graphDataAdditional: GraphDataAdditional) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterGraphData', storeSession.httpToken);
      HubServices.connection.on('GraphDataAdditional', (value: GraphData) => {
        HubServices.graphDataAdditional(value);
      });
    }
    HubServices.graphDataAdditional = graphDataAdditional;
  }

  private static metaAttribDefine: MetaAttribDefine;
  public static onMetaAttribDefine (metaAttribDefine: MetaAttribDefine) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterMetaAttrib', storeSession.httpToken);
      HubServices.connection.on('MetaAttribDefine', (value: MetaAttrib) => {
        HubServices.metaAttribDefine(value);
      });
    }
    HubServices.metaAttribDefine = metaAttribDefine;
  }

  private static dashboardWidgetUpdated: DashboardWidgetUpdated;
  public static onDashboardWidgetUpdated (dashboardWidgetUpdated: DashboardWidgetUpdated) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterDashboardWidget', storeSession.httpToken);
      HubServices.connection.on('DashboardWidgetUpdated', (value: WidgetData) => {
        HubServices.dashboardWidgetUpdated(value);
      });
    }
    HubServices.dashboardWidgetUpdated = dashboardWidgetUpdated;
  }

  private static registerDialog (): void {
    if (!HubServices.ready || HubServices.dialogRegistered || HubServices.dialogRegistration != null) {
      return;
    }

    const connection = HubServices.connection;
    connection.off('DialogQuestion');
    connection.off('DialogAction');
    connection.off('DialogRefresh');
    connection.on('DialogQuestion', (value: Dialog) => {
      HubServices.dialogQuestion?.(value);
    });
    connection.on('DialogAction', (value: DialogActionData) => {
      HubServices.dialogAction?.(value);
    });
    connection.on('DialogRefresh', (value: Dialog) => {
      HubServices.dialogRefresh?.(value);
    });

    const registration = connection.invoke('EnterDialog', storeSession.httpToken)
      .then(() => {
        if (HubServices.ready && HubServices.connection === connection) {
          HubServices.dialogRegistered = true;
        }
      })
      .catch((error: unknown) => {
        console.error('Unable to register dialog hub', error);
        setTimeout(() => HubServices.registerDialog(), 1000);
      })
      .finally(() => {
        if (HubServices.dialogRegistration === registration) {
          HubServices.dialogRegistration = null;
        }
      });
    HubServices.dialogRegistration = registration;
  }

  private static accidentTravailCreated: AccidentTravailCreated;
  private static accidentTravailUpdated: AccidentTravailUpdated;
  private static accidentTravailDeleted: AccidentTravailDeleted;
  public static registerAccidentTravail (created: AccidentTravailCreated, updated: AccidentTravailUpdated, deleted: AccidentTravailDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAccidentTravail', storeSession.httpToken);
      HubServices.connection.on('AccidentTravailCreated', (value: ListItem) => {
        HubServices.accidentTravailCreated(value);
      });
      HubServices.connection.on('AccidentTravailUpdated', (value: ListItem) => {
        HubServices.accidentTravailUpdated(value);
      });
      HubServices.connection.on('AccidentTravailDeleted', (value: ListItem) => {
        HubServices.accidentTravailDeleted(value);
      });
    }
    HubServices.accidentTravailCreated = created;
    HubServices.accidentTravailUpdated = updated;
    HubServices.accidentTravailDeleted = deleted;
  }

  private static accountEntryCreated: AccountEntryCreated;
  private static accountEntryUpdated: AccountEntryUpdated;
  private static accountEntryDeleted: AccountEntryDeleted;
  public static registerAccountEntry (created: AccountEntryCreated, updated: AccountEntryUpdated, deleted: AccountEntryDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAccountEntry', storeSession.httpToken);
      HubServices.connection.on('AccountEntryCreated', (value: ListItem) => {
        HubServices.accountEntryCreated(value);
      });
      HubServices.connection.on('AccountEntryUpdated', (value: ListItem) => {
        HubServices.accountEntryUpdated(value);
      });
      HubServices.connection.on('AccountEntryDeleted', (value: ListItem) => {
        HubServices.accountEntryDeleted(value);
      });
    }
    HubServices.accountEntryCreated = created;
    HubServices.accountEntryUpdated = updated;
    HubServices.accountEntryDeleted = deleted;
  }

  private static activiteCreated: ActiviteCreated;
  private static activiteUpdated: ActiviteUpdated;
  private static activiteDeleted: ActiviteDeleted;
  public static registerActivite (created: ActiviteCreated, updated: ActiviteUpdated, deleted: ActiviteDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterActivite', storeSession.httpToken);
      HubServices.connection.on('ActiviteCreated', (value: ListItem) => {
        HubServices.activiteCreated(value);
      });
      HubServices.connection.on('ActiviteUpdated', (value: ListItem) => {
        HubServices.activiteUpdated(value);
      });
      HubServices.connection.on('ActiviteDeleted', (value: ListItem) => {
        HubServices.activiteDeleted(value);
      });
    }
    HubServices.activiteCreated = created;
    HubServices.activiteUpdated = updated;
    HubServices.activiteDeleted = deleted;
  }

  private static actualiteCreated: ActualiteCreated;
  private static actualiteUpdated: ActualiteUpdated;
  private static actualiteDeleted: ActualiteDeleted;
  public static registerActualite (created: ActualiteCreated, updated: ActualiteUpdated, deleted: ActualiteDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterActualite', storeSession.httpToken);
      HubServices.connection.on('ActualiteCreated', (value: ListItem) => {
        HubServices.actualiteCreated(value);
      });
      HubServices.connection.on('ActualiteUpdated', (value: ListItem) => {
        HubServices.actualiteUpdated(value);
      });
      HubServices.connection.on('ActualiteDeleted', (value: ListItem) => {
        HubServices.actualiteDeleted(value);
      });
    }
    HubServices.actualiteCreated = created;
    HubServices.actualiteUpdated = updated;
    HubServices.actualiteDeleted = deleted;
  }

  private static adresseCreated: AdresseCreated;
  private static adresseUpdated: AdresseUpdated;
  private static adresseDeleted: AdresseDeleted;
  public static registerAdresse (created: AdresseCreated, updated: AdresseUpdated, deleted: AdresseDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAdresse', storeSession.httpToken);
      HubServices.connection.on('AdresseCreated', (value: ListItem) => {
        HubServices.adresseCreated(value);
      });
      HubServices.connection.on('AdresseUpdated', (value: ListItem) => {
        HubServices.adresseUpdated(value);
      });
      HubServices.connection.on('AdresseDeleted', (value: ListItem) => {
        HubServices.adresseDeleted(value);
      });
    }
    HubServices.adresseCreated = created;
    HubServices.adresseUpdated = updated;
    HubServices.adresseDeleted = deleted;
  }

  private static apprentiCreated: ApprentiCreated;
  private static apprentiUpdated: ApprentiUpdated;
  private static apprentiDeleted: ApprentiDeleted;
  public static registerApprenti (created: ApprentiCreated, updated: ApprentiUpdated, deleted: ApprentiDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterApprenti', storeSession.httpToken);
      HubServices.connection.on('ApprentiCreated', (value: ListItem) => {
        HubServices.apprentiCreated(value);
      });
      HubServices.connection.on('ApprentiUpdated', (value: ListItem) => {
        HubServices.apprentiUpdated(value);
      });
      HubServices.connection.on('ApprentiDeleted', (value: ListItem) => {
        HubServices.apprentiDeleted(value);
      });
    }
    HubServices.apprentiCreated = created;
    HubServices.apprentiUpdated = updated;
    HubServices.apprentiDeleted = deleted;
  }

  private static attestationCreated: AttestationCreated;
  private static attestationUpdated: AttestationUpdated;
  private static attestationDeleted: AttestationDeleted;
  public static registerAttestation (created: AttestationCreated, updated: AttestationUpdated, deleted: AttestationDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAttestation', storeSession.httpToken);
      HubServices.connection.on('AttestationCreated', (value: ListItem) => {
        HubServices.attestationCreated(value);
      });
      HubServices.connection.on('AttestationUpdated', (value: ListItem) => {
        HubServices.attestationUpdated(value);
      });
      HubServices.connection.on('AttestationDeleted', (value: ListItem) => {
        HubServices.attestationDeleted(value);
      });
    }
    HubServices.attestationCreated = created;
    HubServices.attestationUpdated = updated;
    HubServices.attestationDeleted = deleted;
  }

  private static attestationDefCreated: AttestationDefCreated;
  private static attestationDefUpdated: AttestationDefUpdated;
  private static attestationDefDeleted: AttestationDefDeleted;
  public static registerAttestationDef (created: AttestationDefCreated, updated: AttestationDefUpdated, deleted: AttestationDefDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAttestationDef', storeSession.httpToken);
      HubServices.connection.on('AttestationDefCreated', (value: ListItem) => {
        HubServices.attestationDefCreated(value);
      });
      HubServices.connection.on('AttestationDefUpdated', (value: ListItem) => {
        HubServices.attestationDefUpdated(value);
      });
      HubServices.connection.on('AttestationDefDeleted', (value: ListItem) => {
        HubServices.attestationDefDeleted(value);
      });
    }
    HubServices.attestationDefCreated = created;
    HubServices.attestationDefUpdated = updated;
    HubServices.attestationDefDeleted = deleted;
  }

  private static authorizedCreditCreated: AuthorizedCreditCreated;
  private static authorizedCreditUpdated: AuthorizedCreditUpdated;
  private static authorizedCreditDeleted: AuthorizedCreditDeleted;
  public static registerAuthorizedCredit (created: AuthorizedCreditCreated, updated: AuthorizedCreditUpdated, deleted: AuthorizedCreditDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterAuthorizedCredit', storeSession.httpToken);
      HubServices.connection.on('AuthorizedCreditCreated', (value: ListItem) => {
        HubServices.authorizedCreditCreated(value);
      });
      HubServices.connection.on('AuthorizedCreditUpdated', (value: ListItem) => {
        HubServices.authorizedCreditUpdated(value);
      });
      HubServices.connection.on('AuthorizedCreditDeleted', (value: ListItem) => {
        HubServices.authorizedCreditDeleted(value);
      });
    }
    HubServices.authorizedCreditCreated = created;
    HubServices.authorizedCreditUpdated = updated;
    HubServices.authorizedCreditDeleted = deleted;
  }

  private static bankCreated: BankCreated;
  private static bankUpdated: BankUpdated;
  private static bankDeleted: BankDeleted;
  public static registerBank (created: BankCreated, updated: BankUpdated, deleted: BankDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterBank', storeSession.httpToken);
      HubServices.connection.on('BankCreated', (value: ListItem) => {
        HubServices.bankCreated(value);
      });
      HubServices.connection.on('BankUpdated', (value: ListItem) => {
        HubServices.bankUpdated(value);
      });
      HubServices.connection.on('BankDeleted', (value: ListItem) => {
        HubServices.bankDeleted(value);
      });
    }
    HubServices.bankCreated = created;
    HubServices.bankUpdated = updated;
    HubServices.bankDeleted = deleted;
  }

  private static billCreated: BillCreated;
  private static billUpdated: BillUpdated;
  private static billDeleted: BillDeleted;
  public static registerBill (created: BillCreated, updated: BillUpdated, deleted: BillDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterBill', storeSession.httpToken);
      HubServices.connection.on('BillCreated', (value: ListItem) => {
        HubServices.billCreated(value);
      });
      HubServices.connection.on('BillUpdated', (value: ListItem) => {
        HubServices.billUpdated(value);
      });
      HubServices.connection.on('BillDeleted', (value: ListItem) => {
        HubServices.billDeleted(value);
      });
    }
    HubServices.billCreated = created;
    HubServices.billUpdated = updated;
    HubServices.billDeleted = deleted;
  }

  private static chatCreated: ChatCreated;
  private static chatUpdated: ChatUpdated;
  private static chatDeleted: ChatDeleted;
  public static registerChat (created: ChatCreated, updated: ChatUpdated, deleted: ChatDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterChat', storeSession.httpToken);
      HubServices.connection.on('ChatCreated', (value: ListItem) => {
        HubServices.chatCreated(value);
      });
      HubServices.connection.on('ChatUpdated', (value: ListItem) => {
        HubServices.chatUpdated(value);
      });
      HubServices.connection.on('ChatDeleted', (value: ListItem) => {
        HubServices.chatDeleted(value);
      });
    }
    HubServices.chatCreated = created;
    HubServices.chatUpdated = updated;
    HubServices.chatDeleted = deleted;
  }

  private static civiliteCreated: CiviliteCreated;
  private static civiliteUpdated: CiviliteUpdated;
  private static civiliteDeleted: CiviliteDeleted;
  public static registerCivilite (created: CiviliteCreated, updated: CiviliteUpdated, deleted: CiviliteDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCivilite', storeSession.httpToken);
      HubServices.connection.on('CiviliteCreated', (value: ListItem) => {
        HubServices.civiliteCreated(value);
      });
      HubServices.connection.on('CiviliteUpdated', (value: ListItem) => {
        HubServices.civiliteUpdated(value);
      });
      HubServices.connection.on('CiviliteDeleted', (value: ListItem) => {
        HubServices.civiliteDeleted(value);
      });
    }
    HubServices.civiliteCreated = created;
    HubServices.civiliteUpdated = updated;
    HubServices.civiliteDeleted = deleted;
  }

  private static clientCreated: ClientCreated;
  private static clientUpdated: ClientUpdated;
  private static clientDeleted: ClientDeleted;
  public static registerClient (created: ClientCreated, updated: ClientUpdated, deleted: ClientDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterClient', storeSession.httpToken);
      HubServices.connection.on('ClientCreated', (value: ListItem) => {
        HubServices.clientCreated(value);
      });
      HubServices.connection.on('ClientUpdated', (value: ListItem) => {
        HubServices.clientUpdated(value);
      });
      HubServices.connection.on('ClientDeleted', (value: ListItem) => {
        HubServices.clientDeleted(value);
      });
    }
    HubServices.clientCreated = created;
    HubServices.clientUpdated = updated;
    HubServices.clientDeleted = deleted;
  }

  private static contactCreated: ContactCreated;
  private static contactUpdated: ContactUpdated;
  private static contactDeleted: ContactDeleted;
  public static registerContact (created: ContactCreated, updated: ContactUpdated, deleted: ContactDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterContact', storeSession.httpToken);
      HubServices.connection.on('ContactCreated', (value: ListItem) => {
        HubServices.contactCreated(value);
      });
      HubServices.connection.on('ContactUpdated', (value: ListItem) => {
        HubServices.contactUpdated(value);
      });
      HubServices.connection.on('ContactDeleted', (value: ListItem) => {
        HubServices.contactDeleted(value);
      });
    }
    HubServices.contactCreated = created;
    HubServices.contactUpdated = updated;
    HubServices.contactDeleted = deleted;
  }

  private static contratCreated: ContratCreated;
  private static contratUpdated: ContratUpdated;
  private static contratDeleted: ContratDeleted;
  public static registerContrat (created: ContratCreated, updated: ContratUpdated, deleted: ContratDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterContrat', storeSession.httpToken);
      HubServices.connection.on('ContratCreated', (value: ListItem) => {
        HubServices.contratCreated(value);
      });
      HubServices.connection.on('ContratUpdated', (value: ListItem) => {
        HubServices.contratUpdated(value);
      });
      HubServices.connection.on('ContratDeleted', (value: ListItem) => {
        HubServices.contratDeleted(value);
      });
    }
    HubServices.contratCreated = created;
    HubServices.contratUpdated = updated;
    HubServices.contratDeleted = deleted;
  }

  private static contratTemplateCreated: ContratTemplateCreated;
  private static contratTemplateUpdated: ContratTemplateUpdated;
  private static contratTemplateDeleted: ContratTemplateDeleted;
  public static registerContratTemplate (created: ContratTemplateCreated, updated: ContratTemplateUpdated, deleted: ContratTemplateDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterContratTemplate', storeSession.httpToken);
      HubServices.connection.on('ContratTemplateCreated', (value: ListItem) => {
        HubServices.contratTemplateCreated(value);
      });
      HubServices.connection.on('ContratTemplateUpdated', (value: ListItem) => {
        HubServices.contratTemplateUpdated(value);
      });
      HubServices.connection.on('ContratTemplateDeleted', (value: ListItem) => {
        HubServices.contratTemplateDeleted(value);
      });
    }
    HubServices.contratTemplateCreated = created;
    HubServices.contratTemplateUpdated = updated;
    HubServices.contratTemplateDeleted = deleted;
  }

  private static creneauCreated: CreneauCreated;
  private static creneauUpdated: CreneauUpdated;
  private static creneauDeleted: CreneauDeleted;
  public static registerCreneau (created: CreneauCreated, updated: CreneauUpdated, deleted: CreneauDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterCreneau', storeSession.httpToken);
      HubServices.connection.on('CreneauCreated', (value: ListItem) => {
        HubServices.creneauCreated(value);
      });
      HubServices.connection.on('CreneauUpdated', (value: ListItem) => {
        HubServices.creneauUpdated(value);
      });
      HubServices.connection.on('CreneauDeleted', (value: ListItem) => {
        HubServices.creneauDeleted(value);
      });
    }
    HubServices.creneauCreated = created;
    HubServices.creneauUpdated = updated;
    HubServices.creneauDeleted = deleted;
  }

  private static deliveryCreated: DeliveryCreated;
  private static deliveryUpdated: DeliveryUpdated;
  private static deliveryDeleted: DeliveryDeleted;
  public static registerDelivery (created: DeliveryCreated, updated: DeliveryUpdated, deleted: DeliveryDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterDelivery', storeSession.httpToken);
      HubServices.connection.on('DeliveryCreated', (value: ListItem) => {
        HubServices.deliveryCreated(value);
      });
      HubServices.connection.on('DeliveryUpdated', (value: ListItem) => {
        HubServices.deliveryUpdated(value);
      });
      HubServices.connection.on('DeliveryDeleted', (value: ListItem) => {
        HubServices.deliveryDeleted(value);
      });
    }
    HubServices.deliveryCreated = created;
    HubServices.deliveryUpdated = updated;
    HubServices.deliveryDeleted = deleted;
  }

  private static documentCreated: DocumentCreated;
  private static documentUpdated: DocumentUpdated;
  private static documentDeleted: DocumentDeleted;
  public static registerDocument (created: DocumentCreated, updated: DocumentUpdated, deleted: DocumentDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterDocument', storeSession.httpToken);
      HubServices.connection.on('DocumentCreated', (value: ListItem) => {
        HubServices.documentCreated(value);
      });
      HubServices.connection.on('DocumentUpdated', (value: ListItem) => {
        HubServices.documentUpdated(value);
      });
      HubServices.connection.on('DocumentDeleted', (value: ListItem) => {
        HubServices.documentDeleted(value);
      });
    }
    HubServices.documentCreated = created;
    HubServices.documentUpdated = updated;
    HubServices.documentDeleted = deleted;
  }

  private static documentTypeCreated: DocumentTypeCreated;
  private static documentTypeUpdated: DocumentTypeUpdated;
  private static documentTypeDeleted: DocumentTypeDeleted;
  public static registerDocumentType (created: DocumentTypeCreated, updated: DocumentTypeUpdated, deleted: DocumentTypeDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterDocumentType', storeSession.httpToken);
      HubServices.connection.on('DocumentTypeCreated', (value: ListItem) => {
        HubServices.documentTypeCreated(value);
      });
      HubServices.connection.on('DocumentTypeUpdated', (value: ListItem) => {
        HubServices.documentTypeUpdated(value);
      });
      HubServices.connection.on('DocumentTypeDeleted', (value: ListItem) => {
        HubServices.documentTypeDeleted(value);
      });
    }
    HubServices.documentTypeCreated = created;
    HubServices.documentTypeUpdated = updated;
    HubServices.documentTypeDeleted = deleted;
  }

  private static etablissementCreated: EtablissementCreated;
  private static etablissementUpdated: EtablissementUpdated;
  private static etablissementDeleted: EtablissementDeleted;
  public static registerEtablissement (created: EtablissementCreated, updated: EtablissementUpdated, deleted: EtablissementDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterEtablissement', storeSession.httpToken);
      HubServices.connection.on('EtablissementCreated', (value: ListItem) => {
        HubServices.etablissementCreated(value);
      });
      HubServices.connection.on('EtablissementUpdated', (value: ListItem) => {
        HubServices.etablissementUpdated(value);
      });
      HubServices.connection.on('EtablissementDeleted', (value: ListItem) => {
        HubServices.etablissementDeleted(value);
      });
    }
    HubServices.etablissementCreated = created;
    HubServices.etablissementUpdated = updated;
    HubServices.etablissementDeleted = deleted;
  }

  private static fractionDsnCreated: FractionDsnCreated;
  private static fractionDsnUpdated: FractionDsnUpdated;
  private static fractionDsnDeleted: FractionDsnDeleted;
  public static registerFractionDsn (created: FractionDsnCreated, updated: FractionDsnUpdated, deleted: FractionDsnDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterFractionDsn', storeSession.httpToken);
      HubServices.connection.on('FractionDsnCreated', (value: ListItem) => {
        HubServices.fractionDsnCreated(value);
      });
      HubServices.connection.on('FractionDsnUpdated', (value: ListItem) => {
        HubServices.fractionDsnUpdated(value);
      });
      HubServices.connection.on('FractionDsnDeleted', (value: ListItem) => {
        HubServices.fractionDsnDeleted(value);
      });
    }
    HubServices.fractionDsnCreated = created;
    HubServices.fractionDsnUpdated = updated;
    HubServices.fractionDsnDeleted = deleted;
  }

  private static lieuCreated: LieuCreated;
  private static lieuUpdated: LieuUpdated;
  private static lieuDeleted: LieuDeleted;
  public static registerLieu (created: LieuCreated, updated: LieuUpdated, deleted: LieuDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterLieu', storeSession.httpToken);
      HubServices.connection.on('LieuCreated', (value: ListItem) => {
        HubServices.lieuCreated(value);
      });
      HubServices.connection.on('LieuUpdated', (value: ListItem) => {
        HubServices.lieuUpdated(value);
      });
      HubServices.connection.on('LieuDeleted', (value: ListItem) => {
        HubServices.lieuDeleted(value);
      });
    }
    HubServices.lieuCreated = created;
    HubServices.lieuUpdated = updated;
    HubServices.lieuDeleted = deleted;
  }

  private static mailCreated: MailCreated;
  private static mailUpdated: MailUpdated;
  private static mailDeleted: MailDeleted;
  public static registerMail (created: MailCreated, updated: MailUpdated, deleted: MailDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterMail', storeSession.httpToken);
      HubServices.connection.on('MailCreated', (value: ListItem) => {
        HubServices.mailCreated(value);
      });
      HubServices.connection.on('MailUpdated', (value: ListItem) => {
        HubServices.mailUpdated(value);
      });
      HubServices.connection.on('MailDeleted', (value: ListItem) => {
        HubServices.mailDeleted(value);
      });
    }
    HubServices.mailCreated = created;
    HubServices.mailUpdated = updated;
    HubServices.mailDeleted = deleted;
  }

  private static manualBillingDocumentCreated: ManualBillingDocumentCreated;
  private static manualBillingDocumentUpdated: ManualBillingDocumentUpdated;
  private static manualBillingDocumentDeleted: ManualBillingDocumentDeleted;
  public static registerManualBillingDocument (created: ManualBillingDocumentCreated, updated: ManualBillingDocumentUpdated, deleted: ManualBillingDocumentDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterManualBillingDocument', storeSession.httpToken);
      HubServices.connection.on('ManualBillingDocumentCreated', (value: ListItem) => {
        HubServices.manualBillingDocumentCreated(value);
      });
      HubServices.connection.on('ManualBillingDocumentUpdated', (value: ListItem) => {
        HubServices.manualBillingDocumentUpdated(value);
      });
      HubServices.connection.on('ManualBillingDocumentDeleted', (value: ListItem) => {
        HubServices.manualBillingDocumentDeleted(value);
      });
    }
    HubServices.manualBillingDocumentCreated = created;
    HubServices.manualBillingDocumentUpdated = updated;
    HubServices.manualBillingDocumentDeleted = deleted;
  }

  private static metaAttribCreated: MetaAttribCreated;
  private static metaAttribUpdated: MetaAttribUpdated;
  private static metaAttribDeleted: MetaAttribDeleted;
  public static registerMetaAttrib (created: MetaAttribCreated, updated: MetaAttribUpdated, deleted: MetaAttribDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterMetaAttrib', storeSession.httpToken);
      HubServices.connection.on('MetaAttribCreated', (value: ListItem) => {
        HubServices.metaAttribCreated(value);
      });
      HubServices.connection.on('MetaAttribUpdated', (value: ListItem) => {
        HubServices.metaAttribUpdated(value);
      });
      HubServices.connection.on('MetaAttribDeleted', (value: ListItem) => {
        HubServices.metaAttribDeleted(value);
      });
    }
    HubServices.metaAttribCreated = created;
    HubServices.metaAttribUpdated = updated;
    HubServices.metaAttribDeleted = deleted;
  }

  private static notifCreated: NotifCreated;
  private static notifUpdated: NotifUpdated;
  private static notifDeleted: NotifDeleted;
  public static registerNotif (created: NotifCreated, updated: NotifUpdated, deleted: NotifDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterNotif', storeSession.httpToken);
      HubServices.connection.on('NotifCreated', (value: ListItem) => {
        HubServices.notifCreated(value);
      });
      HubServices.connection.on('NotifUpdated', (value: ListItem) => {
        HubServices.notifUpdated(value);
      });
      HubServices.connection.on('NotifDeleted', (value: ListItem) => {
        HubServices.notifDeleted(value);
      });
    }
    HubServices.notifCreated = created;
    HubServices.notifUpdated = updated;
    HubServices.notifDeleted = deleted;
  }

  private static numeroCreated: NumeroCreated;
  private static numeroUpdated: NumeroUpdated;
  private static numeroDeleted: NumeroDeleted;
  public static registerNumero (created: NumeroCreated, updated: NumeroUpdated, deleted: NumeroDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterNumero', storeSession.httpToken);
      HubServices.connection.on('NumeroCreated', (value: ListItem) => {
        HubServices.numeroCreated(value);
      });
      HubServices.connection.on('NumeroUpdated', (value: ListItem) => {
        HubServices.numeroUpdated(value);
      });
      HubServices.connection.on('NumeroDeleted', (value: ListItem) => {
        HubServices.numeroDeleted(value);
      });
    }
    HubServices.numeroCreated = created;
    HubServices.numeroUpdated = updated;
    HubServices.numeroDeleted = deleted;
  }

  private static numeroObjetCreated: NumeroObjetCreated;
  private static numeroObjetUpdated: NumeroObjetUpdated;
  private static numeroObjetDeleted: NumeroObjetDeleted;
  public static registerNumeroObjet (created: NumeroObjetCreated, updated: NumeroObjetUpdated, deleted: NumeroObjetDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterNumeroObjet', storeSession.httpToken);
      HubServices.connection.on('NumeroObjetCreated', (value: ListItem) => {
        HubServices.numeroObjetCreated(value);
      });
      HubServices.connection.on('NumeroObjetUpdated', (value: ListItem) => {
        HubServices.numeroObjetUpdated(value);
      });
      HubServices.connection.on('NumeroObjetDeleted', (value: ListItem) => {
        HubServices.numeroObjetDeleted(value);
      });
    }
    HubServices.numeroObjetCreated = created;
    HubServices.numeroObjetUpdated = updated;
    HubServices.numeroObjetDeleted = deleted;
  }

  private static objetMetierCreated: ObjetMetierCreated;
  private static objetMetierUpdated: ObjetMetierUpdated;
  private static objetMetierDeleted: ObjetMetierDeleted;
  public static registerObjetMetier (created: ObjetMetierCreated, updated: ObjetMetierUpdated, deleted: ObjetMetierDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterObjetMetier', storeSession.httpToken);
      HubServices.connection.on('ObjetMetierCreated', (value: ListItem) => {
        HubServices.objetMetierCreated(value);
      });
      HubServices.connection.on('ObjetMetierUpdated', (value: ListItem) => {
        HubServices.objetMetierUpdated(value);
      });
      HubServices.connection.on('ObjetMetierDeleted', (value: ListItem) => {
        HubServices.objetMetierDeleted(value);
      });
    }
    HubServices.objetMetierCreated = created;
    HubServices.objetMetierUpdated = updated;
    HubServices.objetMetierDeleted = deleted;
  }

  private static paieCreated: PaieCreated;
  private static paieUpdated: PaieUpdated;
  private static paieDeleted: PaieDeleted;
  public static registerPaie (created: PaieCreated, updated: PaieUpdated, deleted: PaieDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterPaie', storeSession.httpToken);
      HubServices.connection.on('PaieCreated', (value: ListItem) => {
        HubServices.paieCreated(value);
      });
      HubServices.connection.on('PaieUpdated', (value: ListItem) => {
        HubServices.paieUpdated(value);
      });
      HubServices.connection.on('PaieDeleted', (value: ListItem) => {
        HubServices.paieDeleted(value);
      });
    }
    HubServices.paieCreated = created;
    HubServices.paieUpdated = updated;
    HubServices.paieDeleted = deleted;
  }

  private static paymentMeansCreated: PaymentMeansCreated;
  private static paymentMeansUpdated: PaymentMeansUpdated;
  private static paymentMeansDeleted: PaymentMeansDeleted;
  public static registerPaymentMeans (created: PaymentMeansCreated, updated: PaymentMeansUpdated, deleted: PaymentMeansDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterPaymentMeans', storeSession.httpToken);
      HubServices.connection.on('PaymentMeansCreated', (value: ListItem) => {
        HubServices.paymentMeansCreated(value);
      });
      HubServices.connection.on('PaymentMeansUpdated', (value: ListItem) => {
        HubServices.paymentMeansUpdated(value);
      });
      HubServices.connection.on('PaymentMeansDeleted', (value: ListItem) => {
        HubServices.paymentMeansDeleted(value);
      });
    }
    HubServices.paymentMeansCreated = created;
    HubServices.paymentMeansUpdated = updated;
    HubServices.paymentMeansDeleted = deleted;
  }

  private static plageCreneauCreated: PlageCreneauCreated;
  private static plageCreneauUpdated: PlageCreneauUpdated;
  private static plageCreneauDeleted: PlageCreneauDeleted;
  public static registerPlageCreneau (created: PlageCreneauCreated, updated: PlageCreneauUpdated, deleted: PlageCreneauDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterPlageCreneau', storeSession.httpToken);
      HubServices.connection.on('PlageCreneauCreated', (value: ListItem) => {
        HubServices.plageCreneauCreated(value);
      });
      HubServices.connection.on('PlageCreneauUpdated', (value: ListItem) => {
        HubServices.plageCreneauUpdated(value);
      });
      HubServices.connection.on('PlageCreneauDeleted', (value: ListItem) => {
        HubServices.plageCreneauDeleted(value);
      });
    }
    HubServices.plageCreneauCreated = created;
    HubServices.plageCreneauUpdated = updated;
    HubServices.plageCreneauDeleted = deleted;
  }

  private static projetCreated: ProjetCreated;
  private static projetUpdated: ProjetUpdated;
  private static projetDeleted: ProjetDeleted;
  public static registerProjet (created: ProjetCreated, updated: ProjetUpdated, deleted: ProjetDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterProjet', storeSession.httpToken);
      HubServices.connection.on('ProjetCreated', (value: ListItem) => {
        HubServices.projetCreated(value);
      });
      HubServices.connection.on('ProjetUpdated', (value: ListItem) => {
        HubServices.projetUpdated(value);
      });
      HubServices.connection.on('ProjetDeleted', (value: ListItem) => {
        HubServices.projetDeleted(value);
      });
    }
    HubServices.projetCreated = created;
    HubServices.projetUpdated = updated;
    HubServices.projetDeleted = deleted;
  }

  private static qualiteCreated: QualiteCreated;
  private static qualiteUpdated: QualiteUpdated;
  private static qualiteDeleted: QualiteDeleted;
  public static registerQualite (created: QualiteCreated, updated: QualiteUpdated, deleted: QualiteDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterQualite', storeSession.httpToken);
      HubServices.connection.on('QualiteCreated', (value: ListItem) => {
        HubServices.qualiteCreated(value);
      });
      HubServices.connection.on('QualiteUpdated', (value: ListItem) => {
        HubServices.qualiteUpdated(value);
      });
      HubServices.connection.on('QualiteDeleted', (value: ListItem) => {
        HubServices.qualiteDeleted(value);
      });
    }
    HubServices.qualiteCreated = created;
    HubServices.qualiteUpdated = updated;
    HubServices.qualiteDeleted = deleted;
  }

  private static ribCreated: RibCreated;
  private static ribUpdated: RibUpdated;
  private static ribDeleted: RibDeleted;
  public static registerRib (created: RibCreated, updated: RibUpdated, deleted: RibDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterRib', storeSession.httpToken);
      HubServices.connection.on('RibCreated', (value: ListItem) => {
        HubServices.ribCreated(value);
      });
      HubServices.connection.on('RibUpdated', (value: ListItem) => {
        HubServices.ribUpdated(value);
      });
      HubServices.connection.on('RibDeleted', (value: ListItem) => {
        HubServices.ribDeleted(value);
      });
    }
    HubServices.ribCreated = created;
    HubServices.ribUpdated = updated;
    HubServices.ribDeleted = deleted;
  }

  private static rubriqueCreated: RubriqueCreated;
  private static rubriqueUpdated: RubriqueUpdated;
  private static rubriqueDeleted: RubriqueDeleted;
  public static registerRubrique (created: RubriqueCreated, updated: RubriqueUpdated, deleted: RubriqueDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterRubrique', storeSession.httpToken);
      HubServices.connection.on('RubriqueCreated', (value: ListItem) => {
        HubServices.rubriqueCreated(value);
      });
      HubServices.connection.on('RubriqueUpdated', (value: ListItem) => {
        HubServices.rubriqueUpdated(value);
      });
      HubServices.connection.on('RubriqueDeleted', (value: ListItem) => {
        HubServices.rubriqueDeleted(value);
      });
    }
    HubServices.rubriqueCreated = created;
    HubServices.rubriqueUpdated = updated;
    HubServices.rubriqueDeleted = deleted;
  }

  private static salarieCreated: SalarieCreated;
  private static salarieUpdated: SalarieUpdated;
  private static salarieDeleted: SalarieDeleted;
  public static registerSalarie (created: SalarieCreated, updated: SalarieUpdated, deleted: SalarieDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSalarie', storeSession.httpToken);
      HubServices.connection.on('SalarieCreated', (value: ListItem) => {
        HubServices.salarieCreated(value);
      });
      HubServices.connection.on('SalarieUpdated', (value: ListItem) => {
        HubServices.salarieUpdated(value);
      });
      HubServices.connection.on('SalarieDeleted', (value: ListItem) => {
        HubServices.salarieDeleted(value);
      });
    }
    HubServices.salarieCreated = created;
    HubServices.salarieUpdated = updated;
    HubServices.salarieDeleted = deleted;
  }

  private static subscriptionCreated: SubscriptionCreated;
  private static subscriptionUpdated: SubscriptionUpdated;
  private static subscriptionDeleted: SubscriptionDeleted;
  public static registerSubscription (created: SubscriptionCreated, updated: SubscriptionUpdated, deleted: SubscriptionDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSubscription', storeSession.httpToken);
      HubServices.connection.on('SubscriptionCreated', (value: ListItem) => {
        HubServices.subscriptionCreated(value);
      });
      HubServices.connection.on('SubscriptionUpdated', (value: ListItem) => {
        HubServices.subscriptionUpdated(value);
      });
      HubServices.connection.on('SubscriptionDeleted', (value: ListItem) => {
        HubServices.subscriptionDeleted(value);
      });
    }
    HubServices.subscriptionCreated = created;
    HubServices.subscriptionUpdated = updated;
    HubServices.subscriptionDeleted = deleted;
  }

  private static subscriptionTypeCreated: SubscriptionTypeCreated;
  private static subscriptionTypeUpdated: SubscriptionTypeUpdated;
  private static subscriptionTypeDeleted: SubscriptionTypeDeleted;
  public static registerSubscriptionType (created: SubscriptionTypeCreated, updated: SubscriptionTypeUpdated, deleted: SubscriptionTypeDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSubscriptionType', storeSession.httpToken);
      HubServices.connection.on('SubscriptionTypeCreated', (value: ListItem) => {
        HubServices.subscriptionTypeCreated(value);
      });
      HubServices.connection.on('SubscriptionTypeUpdated', (value: ListItem) => {
        HubServices.subscriptionTypeUpdated(value);
      });
      HubServices.connection.on('SubscriptionTypeDeleted', (value: ListItem) => {
        HubServices.subscriptionTypeDeleted(value);
      });
    }
    HubServices.subscriptionTypeCreated = created;
    HubServices.subscriptionTypeUpdated = updated;
    HubServices.subscriptionTypeDeleted = deleted;
  }

  private static supportCreated: SupportCreated;
  private static supportUpdated: SupportUpdated;
  private static supportDeleted: SupportDeleted;
  public static registerSupport (created: SupportCreated, updated: SupportUpdated, deleted: SupportDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterSupport', storeSession.httpToken);
      HubServices.connection.on('SupportCreated', (value: ListItem) => {
        HubServices.supportCreated(value);
      });
      HubServices.connection.on('SupportUpdated', (value: ListItem) => {
        HubServices.supportUpdated(value);
      });
      HubServices.connection.on('SupportDeleted', (value: ListItem) => {
        HubServices.supportDeleted(value);
      });
    }
    HubServices.supportCreated = created;
    HubServices.supportUpdated = updated;
    HubServices.supportDeleted = deleted;
  }

  private static transactionCreated: TransactionCreated;
  private static transactionUpdated: TransactionUpdated;
  private static transactionDeleted: TransactionDeleted;
  public static registerTransaction (created: TransactionCreated, updated: TransactionUpdated, deleted: TransactionDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterTransaction', storeSession.httpToken);
      HubServices.connection.on('TransactionCreated', (value: ListItem) => {
        HubServices.transactionCreated(value);
      });
      HubServices.connection.on('TransactionUpdated', (value: ListItem) => {
        HubServices.transactionUpdated(value);
      });
      HubServices.connection.on('TransactionDeleted', (value: ListItem) => {
        HubServices.transactionDeleted(value);
      });
    }
    HubServices.transactionCreated = created;
    HubServices.transactionUpdated = updated;
    HubServices.transactionDeleted = deleted;
  }

  private static userCreated: UserCreated;
  private static userUpdated: UserUpdated;
  private static userDeleted: UserDeleted;
  public static registerUser (created: UserCreated, updated: UserUpdated, deleted: UserDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterUser', storeSession.httpToken);
      HubServices.connection.on('UserCreated', (value: ListItem) => {
        HubServices.userCreated(value);
      });
      HubServices.connection.on('UserUpdated', (value: ListItem) => {
        HubServices.userUpdated(value);
      });
      HubServices.connection.on('UserDeleted', (value: ListItem) => {
        HubServices.userDeleted(value);
      });
    }
    HubServices.userCreated = created;
    HubServices.userUpdated = updated;
    HubServices.userDeleted = deleted;
  }

  private static wizardItemCreated: WizardItemCreated;
  private static wizardItemUpdated: WizardItemUpdated;
  private static wizardItemDeleted: WizardItemDeleted;
  public static registerWizardItem (created: WizardItemCreated, updated: WizardItemUpdated, deleted: WizardItemDeleted) {
    if (HubServices.ready) {
      HubServices.connection.invoke('EnterWizardItem', storeSession.httpToken);
      HubServices.connection.on('WizardItemCreated', (value: ListItem) => {
        HubServices.wizardItemCreated(value);
      });
      HubServices.connection.on('WizardItemUpdated', (value: ListItem) => {
        HubServices.wizardItemUpdated(value);
      });
      HubServices.connection.on('WizardItemDeleted', (value: ListItem) => {
        HubServices.wizardItemDeleted(value);
      });
    }
    HubServices.wizardItemCreated = created;
    HubServices.wizardItemUpdated = updated;
    HubServices.wizardItemDeleted = deleted;
  }
}
